<template>
  <div class="link">
    <div class="update-prompt">
      <img src="@/assets/img/jump.png" alt />
      <div class="tips">{{countdown}}&nbsp;秒钟后跳转</div>
      <div class="content">
        <h2>【{{this.$route.query.name}}】更新日志</h2>
        <div class="time" v-if="updateInfo">上线时间：{{updateInfo.online_time | dataFormatter}}</div>
        <ul class="describe">
          <li v-for="x in updateInfo.content" :key="x">{{x}}</li>
        </ul>
        <div class="action-bar">
          <router-link :to="'/product-dynamic?key='+$route.query.name" @click.native="clearTimer()">
            <el-button type="primary" round>更多产品动态</el-button>
          </router-link>
          <a :href="$route.query.url">
            <br />直接跳转
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "linkTips",
  data() {
    return {
      countdown: 3,
      updateInfo: "",
      timer: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      _api.product
        .getDynamicsList({
          system_key: this.$route.query.key,
          page: 1,
          page_size: 1
        })
        .then(res => {
          this.updateInfo = res.data.rows[0];

          this.updateInfo.content = this.updateInfo.content.split(/\r?\n/g);
          _api.product.postSaveDynamicVisitLog({
            dynamic_id: this.updateInfo.id
          });
        });
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown == 0) {
          clearInterval(this.timer);
          window.location.href = this.$route.query.url;
        }
      }, 1000);
    },
    clearTimer() {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  height: 100%;
  width: 100%;
  background-color: #808080;
  padding-top: 200px;
  color: #333;
  .update-prompt {
    margin: 0 auto;
    width: 500px;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    img {
      margin-top: -43px;
    }
    .tips {
      position: absolute;
      top: 90px;
      left: 30px;
      font-size: 16px;
      color: #fff;
    }
    .content {
      padding: 10px 30px;
      h2 {
        line-height: 24px;
        height: 24px;
        color: #333;
      }
      .time {
        line-height: 40px;
        height: 40px;
        margin-left: 15px;
      }
      .describe {
        line-height: 22px;
        background-color: #f2f6fc;
        font-size: 14px;
        padding: 16px;
        li {
          list-style: inside;
        }
      }
    }
    .action-bar {
      display: flex;
      justify-content: space-around;
      margin: 30px 0;
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
